import { observer, inject } from 'mobx-react';
import React, { Component } from 'react';
import { Link }             from 'react-router-dom';

function ServerErrorPage() {
    return (
        <div className="container all-white">
            <div className="jumbotron all-white">
                <h1>Sorry! We're having a few difficulties.  Please try again soon.</h1>
            </div>
        </div>
    );
}

export { 
    ServerErrorPage
}